import { SellerServices } from '@/services/seller.services'
import { ProductServices } from '@/services/product.service'

const state = {
  stepsellerreg: 1,
  loading: false,
  loadingbuyer: true,
  dialog: false,
  buyers: [],
  hargakhusus: [],
  totalhargakhusus: 0,
  dialogaddprodukmember: false,
  dialoghargakhusus: false,
  overlay: false,
  productseller: [],
  totalproductseller: 0,
  trxseller: [],
  totaltrxseller: 0,
  tokostatus: false,
  sellerapi: {
    jenisapi: 0,
    username: '',
    password: '',
    userid: 'PA0001',
    pin: '',
    apiurl: ''
  },
  sumsell: [0, 0],
  apitestresult: '',
  sellerdoc: {
    ktp: '',
    npwp: ''
  },
  nbrands: [],
  nproduct: [],
  selectproductseller: {},
  selectproductbybrand: []
}
const actions = {
  setsellerktp ({ commit }, data) {
    commit('setsellerktp', data)
  },
  setsellernpwp ({ commit }, data) {
    commit('setsellernpwp', data)
  },
  setlocalStatustoko ({ commit }, data) {
    commit('settokostatuslocal', data)
  },
  setstepsellerreg ({ commit }, data) {
    commit('setstepseller', data)
  },
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialoghargakhusus ({ commit }, diag) {
    commit('setdialoghargakhusus', diag)
  },
  setdialogproductmember ({ commit }, diag) {
    commit('setdialogproductmember', diag)
  },
  doSyncHarga ({ dispatch, commit }) {
    commit('setloading', true)
    SellerServices.syncharga().then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  setSellerDocument ({ dispatch, commit }, data) {
    commit('setloading', true)
    SellerServices.setSellerDocument(data).then(value => {
      commit('setloading', false)
      commit('setstepseller', 2)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getSumsell ({ dispatch, commit }) {
    commit('setloading', true)
    SellerServices.getSumSell().then(value => {
      commit('setloading', false)
      commit('setdatasumsell', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getStatustoko ({ dispatch, commit }) {
    commit('setloading', true)
    SellerServices.getStatustoko().then(value => {
      commit('setloading', false)
      commit('settokostatus', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  setSellerAPI ({ dispatch, commit }, data) {
    commit('setloading', true)
    SellerServices.setAPISeller(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  simpanSellerAPI ({ dispatch, commit }, data) {
    commit('setloading', true)
    SellerServices.setAPISeller(data).then(value => {
      commit('setloading', false)
      commit('setstepseller', 4)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getSellerAPI ({ dispatch, commit }, id) {
    commit('setloading', true)
    SellerServices.getSellerAPI(id).then(value => {
      commit('setloading', false)
      commit('setsellerapi', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  updateStatusToko ({ dispatch, commit }, status) {
    commit('setloading', true)
    SellerServices.updateStatusToko(status).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  updateProductSeller ({ dispatch, commit }, data) {
    commit('setloading', true)
    SellerServices.updateProductSeller(data).then(value => {
      commit('setloading', false)
      commit('setdialog', false)
      dispatch('alert/success', value.msg, { root: true })
      var ss = JSON.parse(localStorage.getItem('getproductseller_value'))
      SellerServices.getProductSeller(ss).then(value => {
        commit('setloading', false)
        commit('setproductseller', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
        dispatch('alert/error', reason, { root: true })
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  deleteProductSeller ({ dispatch, commit }, id) {
    commit('setloading', true)
    SellerServices.deleteProductSeller(id).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
      var ss = JSON.parse(localStorage.getItem('getproductseller_value'))
      SellerServices.getProductSeller(ss).then(value => {
        commit('setloading', false)
        commit('setproductseller', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
        dispatch('alert/error', reason, { root: true })
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getProductSeller ({ dispatch, commit }, opt) {
    commit('setloading', true)
    localStorage.setItem('getproductseller_value', JSON.stringify(opt))
    SellerServices.getProductSeller(opt).then(value => {
      commit('setloading', false)
      commit('setproductseller', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getProductSellerByID ({ dispatch, commit }, productid) {
    commit('setloading', true)
    SellerServices.getProductSellerbyIdProduct(productid).then(value => {
      commit('setloading', false)
      commit('setselectproductseller', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  addProductSeller ({ dispatch, commit }, opt) {
    commit('setloading', true)
    SellerServices.addProductSeller(opt).then(value => {
      commit('setloading', false)
      commit('setdialogproductmember', false)
      dispatch('alert/success', value.msg, { root: true })
      var ss = JSON.parse(localStorage.getItem('getproductseller_value'))
      SellerServices.getProductSeller(ss).then(value => {
        commit('setloading', false)
        commit('setproductseller', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
        dispatch('alert/error', reason, { root: true })
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getTrxSeller ({ dispatch, commit }, opt) {
    commit('setloading', true)
    SellerServices.getTrxSell(opt).then(value => {
      commit('setloading', false)
      commit('settrxseller', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  updateTrxSeller ({ dispatch, commit }, data) {
    commit('setloading', true)
    SellerServices.updateTrxSeller(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', value.msg, { root: true })
    }).catch(reason => {
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  doAPITest ({ dispatch, commit }, opt) {
    commit('setloading', true)
    SellerServices.apitest(opt).then(value => {
      commit('setloading', false)
      commit('setdataapiresult', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getnBrandsByid ({ dispatch, commit }, brandid) {
    commit('setloading', true)
    ProductServices.getBrandsByid(brandid).then(value => {
      commit('setloading', false)
      commit('setnbrands', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getnProductByBrandId ({ dispatch, commit }, productid) {
    commit('setloading', true)
    ProductServices.getProcuctByBrandId(productid).then(value => {
      commit('setloading', false)
      commit('setnproduct', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getSellerProductByBrandID ({ dispatch, commit }, brandid) {
    commit('setloading', true)
    SellerServices.getProductSellerbyBrandID(brandid).then(value => {
      commit('setloading', false)
      commit('setselectproductbybrand', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getBuyerList ({ dispatch, commit }, search) {
    commit('setloading', true)
    SellerServices.getListBuyer(search).then(value => {
      commit('setloading', false)
      commit('setdatabuyer', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getProductSpecial ({ dispatch, commit }, opt) {
    commit('setloading', true)
    SellerServices.getProductSpecial(opt).then(value => {
      commit('setloading', false)
      commit('setdataproductspecial', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  addProductSpecial ({ dispatch, commit }, data) {
    commit('setloading', true)
    SellerServices.addProductSpecial(data).then(value => {
      commit('setloading', false)
      commit('setdialoghargakhusus', false)
      dispatch('getProductSpecial')
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  delProductSpecial ({ dispatch, commit }, data) {
    commit('setloading', true)
    SellerServices.delProductSpecial(data).then(value => {
      commit('setloading', false)
      dispatch('getProductSpecial')
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogproductmember (state, s) {
    state.dialogaddprodukmember = s
  },
  setdialoghargakhusus (state, s) {
    state.dialoghargakhusus = s
  },
  settrxseller (state, s) {
    state.trxseller = []
    state.trxseller = s.data.content
    state.totaltrxseller = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdatabuyer (state, s) {
    state.buyers = []
    state.buyers = s.data
    state.loadingbuyer = false
  },
  setselectproductseller (state, s) {
    state.selectproductseller = []
    state.selectproductseller = s.data
    state.loading = false
    state.overlay = false
  },
  setselectproductbybrand (state, s) {
    state.selectproductbybrand = []
    state.selectproductbybrand = s.data.content
    state.loading = false
    state.overlay = false
  },
  setproductseller (state, s) {
    state.productseller = []
    state.productseller = s.data.content
    state.totalproductseller = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdataproductspecial (state, s) {
    state.hargakhusus = []
    state.hargakhusus = s.data.content
    state.totalhargakhusus = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setsellerapi (state, s) {
    state.sellerapi = []
    state.sellerapi = s.data
    state.loading = false
    state.overlay = false
  },
  settokostatus (state, s) {
    state.tokostatus = false
    state.tokostatus = s.data !== 0
    state.loading = false
    state.overlay = false
  },
  settokostatuslocal (state, s) {
    state.tokostatus = s
  },
  setdatasumsell (state, s) {
    state.sumsell = []
    state.sumsell = s.data
    state.loading = false
    state.overlay = false
  },
  setdataapiresult (state, s) {
    state.apitestresult = ''
    state.apitestresult = s.data
    state.loading = false
    state.overlay = false
  },
  setstepseller (state, s) {
    state.stepsellerreg = s
  },
  setsellerktp (state, s) {
    state.sellerdoc.ktp = s
  },
  setsellernpwp (state, s) {
    state.sellerdoc.npwp = s
  },
  setnbrands (state, s) {
    state.nbrands = s.data
  },
  setnproduct (state, s) {
    state.nproduct = s.data
  }
}

export const SellerStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
